// removed by extract-text-webpack-plugin
module.exports = {"root":"_25zrD"};


//////////////////
// WEBPACK FOOTER
// ./app/components/authCard/CardContent/CardContent.scss
// module id = 1162
// module chunks = 1